import { Component, Inject, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { StaticFields } from '../../shared/staticFields';
import { CustomMessageService } from '../../services/custom.message.service';
import { Settings } from 'src/app/models/settings';
import { SettingService } from 'src/app/services/setting.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  hideEditorCtrl = false;
  homeScreenData = {   
    "appUserId" : "",
    "box1" : "",
    "box2" : "",
    "box3" : "",
    "box4" : "",
    "mappingModel" : ""
  };
  isAdmin = false;
  isPCMAdmin: boolean = false;
  isPCMUser: boolean = false;
  envText: string;
  
  constructor(@Inject(SettingService) private config: Settings, public customMessageService: CustomMessageService, private apiService : ApiService, private confirmationService: ConfirmationService) { }
 
  ngOnInit(): void {    
    this.isPCMAdmin = StaticFields.userClaim.isPCMAdmin;
    this.isPCMUser= StaticFields.userClaim.isPCMUser;
    
    if (StaticFields.appUserId) {
      StaticFields.homeScreenData.appUserId = StaticFields.appUserId;
      this.homeScreenData = StaticFields.homeScreenData;
      if (this.config.environment.toUpperCase() === 'LOCAL' || this.config.environment.toUpperCase() === 'DEV' || this.config.environment.toUpperCase() === 'QA' || this.config.environment.toUpperCase() === 'TR')
        this.envText = StaticFields.isNSLProd ? "Precode Manager is pointing to NSL Production data at this time." : "Precode Manager is pointing to NSL QA data at this time.";
    }
    else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId) {
          StaticFields.homeScreenData.appUserId = StaticFields.appUserId;
          this.homeScreenData = StaticFields.homeScreenData;
          if (this.config.environment.toUpperCase() === 'LOCAL' || this.config.environment.toUpperCase() === 'DEV' || this.config.environment.toUpperCase() === 'QA' || this.config.environment.toUpperCase() === 'TR')
            this.envText = StaticFields.isNSLProd ? "Precode Manager is pointing to NSL Production data at this time." : "Precode Manager is pointing to NSL QA data at this time.";
          clearInterval(interval);
        }       
      }, 600);
    }
    const elements = document.getElementsByClassName("footer-container");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = 'inline';
    }
  } 
  
  editContent() {
    this.hideEditorCtrl = true;
  }

  cancelEdit() {
    this.confirmationService.confirm({
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      message: 'Are you sure you want to cancel the changes made?',
      accept: () => {
        this.hideEditorCtrl = false;
        this.homeScreenData = StaticFields.homeScreenData ? StaticFields.homeScreenData : this.homeScreenData;
          //Actual logic to perform a confirmation
      }
    });    
  }

  saveHomePageData() {   
    this.apiService.putData('SubmitHomePageData', this.homeScreenData).subscribe((result : any)  => {
      this.homeScreenData = StaticFields.homeScreenData = result;
      this.hideEditorCtrl = false;     
    });
  }
}